"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let NumberingSelector = class NumberingSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    objectType;
    onObject_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("objectType");
    }
    name;
    onName(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("name");
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    bindObject;
    onBind_object(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("bindObject");
    }
    internalValue;
    async $$load_internalValue() {
        return this.bindObject ? (this.value ? this.value.id : null) : this.value;
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_numbering', { parameters: { resource_type: this.objectType } })
            .then(d => [{ id: null, description: this.$fn.gettext('Manual') }].concat(d));
    }
    ux;
    b_7315092382398562_filterable;
    b_7315092382398562_searchable;
    dataMembers = ['internalValue', 'items', 'ux', 'b_7315092382398562_filterable', 'b_7315092382398562_searchable'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                internalValue: null,
                items: null,
                ux: null,
                b_7315092382398562_filterable: false,
                b_7315092382398562_searchable: false,
            },
        };
    }
    async act_7315092382398562_emit_5154_getActionArgs($event) {
        return {
            event: "input",
            value: this.bindObject ? { id: $event.originalEvent } : $event.originalEvent,
        };
    }
    async evh_7315092382398562_input(event, scope) {
        return await this.actions.evh_7315092382398562_input.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_register_5158_getActionArgs($event) {
        return {
            name: "resultID",
            value: $event.data.modalResult && $event.data.modalResult.ok && $event.data.modalResult.value.id,
        };
    }
    async evh_3343864469950044_close_5159_getWhen($event) {
        return $event.data.resultID;
    }
    async act_3343864469950044_setData_5162_getActionArgs($event) {
        return {
            path: "internalValue",
            value: this.resultID,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_3343864469950044_close_5161_getWhen($event) {
        return $event.data.resultID;
    }
    async act_3343864469950044_showModal_5156_getActionArgs($event) {
        return {
            name: "Numbering",
            props: {
                objectType: this.objectType,
            },
        };
    }
    async evh_3343864469950044_click(event, scope) {
        return await this.actions.evh_3343864469950044_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_emit_5154 = new core_1.actions.EmitAction({
            actionArgs: this.act_7315092382398562_emit_5154_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_input_5153 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_emit_5154,
            event: "input",
            displayName: "emit",
        });
        const evh_7315092382398562_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_input_5153],
        });
        const act_3343864469950044_register_5158 = new core_1.actions.RegisterAction({
            actionArgs: this.act_3343864469950044_register_5158_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_close_5157 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_register_5158,
            event: "close",
            displayName: "register",
        });
        const act_3343864469950044_reloadComponentData_5160 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_3343864469950044_close_5159 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_reloadComponentData_5160,
            event: "close",
            when: this.evh_3343864469950044_close_5159_getWhen,
            displayName: "reloadComponentData",
        });
        const act_3343864469950044_setData_5162 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3343864469950044_setData_5162_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_close_5161 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_setData_5162,
            event: "close",
            when: this.evh_3343864469950044_close_5161_getWhen,
            displayName: "setData",
        });
        const act_3343864469950044_showModal_5156 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3343864469950044_showModal_5156_getActionArgs,
            events: [evh_3343864469950044_close_5157, evh_3343864469950044_close_5159, evh_3343864469950044_close_5161],
        });
        const evh_3343864469950044_click_5155 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_showModal_5156,
            event: "click",
            displayName: "showModal",
        });
        const evh_3343864469950044_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_click_5155],
        });
        return {
            act_7315092382398562_emit_5154,
            evh_7315092382398562_input_5153,
            evh_7315092382398562_input,
            act_3343864469950044_register_5158,
            evh_3343864469950044_close_5157,
            act_3343864469950044_reloadComponentData_5160,
            evh_3343864469950044_close_5159,
            act_3343864469950044_setData_5162,
            evh_3343864469950044_close_5161,
            act_3343864469950044_showModal_5156,
            evh_3343864469950044_click_5155,
            evh_3343864469950044_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], NumberingSelector.prototype, "objectType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('objectType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NumberingSelector.prototype, "onObject_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], NumberingSelector.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('name'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NumberingSelector.prototype, "onName", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
    }),
    __metadata("design:type", Object)
], NumberingSelector.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NumberingSelector.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], NumberingSelector.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NumberingSelector.prototype, "onReadonly", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], NumberingSelector.prototype, "bindObject", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('bindObject'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], NumberingSelector.prototype, "onBind_object", null);
NumberingSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], NumberingSelector);
exports.default = NumberingSelector;
vue_property_decorator_1.Vue.component("NumberingSelector", NumberingSelector);
